









import Vue from "vue";
import { CloudSettingService } from "@/services/cloudSettingService";
import { Info } from "../../models/Info";
import { CloudSetting } from "../../models/CloudSetting";

export default Vue.extend({
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  data() {
    return {
      lockingStatusLabel: "Lock",
      status: this.info.selectedDevice.deviceLockStatus,
      deviceId: this.info.selectedDevice.deviceUDID
    };
  },
  methods: {
    async changeStatus() {
      if (this.status === true) {
        this.status = false;
      } else {
        this.status = true;
      }
      const result = await CloudSettingService.updateDeviceLockStatus(this.info.selectedDevice.deviceUDID, this.status);
    }
  },
  watch: {
    "info.selectedDevice"(newValue: CloudSetting) {
      this.deviceId = newValue.deviceUDID;
      this.status = newValue.deviceLockStatus;
    },
    status(newValue: boolean) {
      if (this.info.cloudSettings) {
        this.info.cloudSettings.forEach(element => {
          if (element.deviceUDID == this.deviceId) {
            element.deviceLockStatus = newValue;
          }
        });
      }
    }
  }
});
